var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", { staticClass: "terms__content" }, [
    _c("p", [_vm._v(_vm._s(_vm.$t("privacy.firstPart.text[0]")))]),
    _vm._v(" "),
    _c("p", [
      _vm._v("\n    " + _vm._s(_vm.$t("privacy.firstPart.text[1]")) + "\n    "),
      _c("a", { attrs: { href: "mailto:" + _vm.supportEmail } }, [
        _vm._v(_vm._s(_vm.supportEmail))
      ])
    ]),
    _vm._v(" "),
    _c("p", [_vm._v(_vm._s(_vm.$t("privacy.firstPart.text[2]")))]),
    _vm._v(" "),
    _c("p", [_vm._v(_vm._s(_vm.$t("privacy.firstPart.text[3]")))]),
    _vm._v(" "),
    _c("p", { staticClass: "no-margin" }, [
      _vm._v(_vm._s(_vm.$t("privacy.firstPart.clarification[0]")))
    ]),
    _vm._v(" "),
    _c("p", { staticClass: "no-margin" }, [
      _vm._v(_vm._s(_vm.$t("privacy.firstPart.clarification[1]")))
    ]),
    _vm._v(" "),
    _c("p", { staticClass: "no-margin" }, [
      _vm._v(_vm._s(_vm.$t("privacy.firstPart.clarification[2]")))
    ]),
    _vm._v(" "),
    _c("p", { staticClass: "no-margin" }, [
      _vm._v(_vm._s(_vm.$t("privacy.firstPart.clarification[3]")))
    ]),
    _vm._v(" "),
    _c("p", { staticClass: "no-margin" }, [
      _vm._v(_vm._s(_vm.$t("privacy.firstPart.clarification[4]")))
    ]),
    _vm._v(" "),
    _c("p", { staticClass: "no-margin" }, [
      _vm._v(_vm._s(_vm.$t("privacy.firstPart.clarification[5]")))
    ]),
    _vm._v(" "),
    _c("p", { staticClass: "no-margin" }, [
      _vm._v(_vm._s(_vm.$t("privacy.firstPart.clarification[6]")))
    ]),
    _vm._v(" "),
    _c("p", [_vm._v(_vm._s(_vm.$t("privacy.firstPart.text[4]")))]),
    _vm._v(" "),
    _c("p", [
      _vm._v(_vm._s(_vm.$t("privacy.firstPart.text[5]")) + "\n    "),
      _c("a", { attrs: { href: "mailto:" + _vm.supportEmail } }, [
        _vm._v(_vm._s(_vm.supportEmail))
      ]),
      _vm._v(".")
    ]),
    _vm._v(" "),
    _c("p", [_vm._v(_vm._s(_vm.$t("privacy.firstPart.text[6]")))]),
    _vm._v(" "),
    _c("p", [_vm._v(_vm._s(_vm.$t("privacy.firstPart.text[7]")))]),
    _vm._v(" "),
    _c("h3", [_vm._v(_vm._s(_vm.$t("privacy.list[0].title")))]),
    _vm._v(" "),
    _c("p", [_vm._v(_vm._s(_vm.$t("privacy.list[0].text[0]")))]),
    _vm._v(" "),
    _c("p", [_vm._v(_vm._s(_vm.$t("privacy.list[0].text[1]")))]),
    _vm._v(" "),
    _c("p", [_vm._v(_vm._s(_vm.$t("privacy.list[0].text[2]")))]),
    _vm._v(" "),
    _c("p", [_vm._v(_vm._s(_vm.$t("privacy.list[0].text[3]")))]),
    _vm._v(" "),
    _c("p", [_vm._v(_vm._s(_vm.$t("privacy.list[0].text[4]")))]),
    _vm._v(" "),
    _c("p", [_vm._v(_vm._s(_vm.$t("privacy.list[0].text[5]")))]),
    _vm._v(" "),
    _c("p", [_vm._v(_vm._s(_vm.$t("privacy.list[0].text[6]")))]),
    _vm._v(" "),
    _c("p", [_vm._v(_vm._s(_vm.$t("privacy.list[0].text[7]")))]),
    _vm._v(" "),
    _c("p", [_vm._v(_vm._s(_vm.$t("privacy.list[0].text[8]")))]),
    _vm._v(" "),
    _c("p", [_vm._v(_vm._s(_vm.$t("privacy.list[0].text[9]")))]),
    _vm._v(" "),
    _c("p", [_vm._v(_vm._s(_vm.$t("privacy.list[0].text[10]")))]),
    _vm._v(" "),
    _c("p", [_vm._v(_vm._s(_vm.$t("privacy.list[0].text[11]")))]),
    _vm._v(" "),
    _c("p", [_vm._v(_vm._s(_vm.$t("privacy.list[0].text[12]")))]),
    _vm._v(" "),
    _c("h3", [_vm._v(_vm._s(_vm.$t("privacy.list[1].title")))]),
    _vm._v(" "),
    _c("p", [_vm._v(_vm._s(_vm.$t("privacy.list[1].text[0]")))]),
    _vm._v(" "),
    _c("p", [_vm._v(_vm._s(_vm.$t("privacy.list[1].text[1]")))]),
    _vm._v(" "),
    _c("p", [_vm._v(_vm._s(_vm.$t("privacy.list[1].text[2]")))]),
    _vm._v(" "),
    _c("p", [_vm._v(_vm._s(_vm.$t("privacy.list[1].text[3]")))]),
    _vm._v(" "),
    _c("p", [_vm._v(_vm._s(_vm.$t("privacy.list[1].text[4]")))]),
    _vm._v(" "),
    _c("p", [_vm._v(_vm._s(_vm.$t("privacy.list[1].text[5]")))]),
    _vm._v(" "),
    _c("h3", [_vm._v(_vm._s(_vm.$t("privacy.list[2].title")))]),
    _vm._v(" "),
    _c("p", [_vm._v(_vm._s(_vm.$t("privacy.list[2].text[0]")))]),
    _vm._v(" "),
    _c("p", { staticClass: "no-margin" }, [
      _vm._v(_vm._s(_vm.$t("privacy.list[2].clarification[0]")))
    ]),
    _vm._v(" "),
    _c("p", { staticClass: "no-margin" }, [
      _vm._v(_vm._s(_vm.$t("privacy.list[2].clarification[1]")))
    ]),
    _vm._v(" "),
    _c("p", { staticClass: "no-margin" }, [
      _vm._v(_vm._s(_vm.$t("privacy.list[2].clarification[2]")))
    ]),
    _vm._v(" "),
    _c("p", [_vm._v(_vm._s(_vm.$t("privacy.list[2].text[1]")))]),
    _vm._v(" "),
    _c("p", [_vm._v(_vm._s(_vm.$t("privacy.list[2].text[2]")))]),
    _vm._v(" "),
    _c("p", [_vm._v(_vm._s(_vm.$t("privacy.list[2].text[3]")))]),
    _vm._v(" "),
    _c("h3", [_vm._v(_vm._s(_vm.$t("privacy.list[3].title")))]),
    _vm._v(" "),
    _c("p", [_vm._v(_vm._s(_vm.$t("privacy.list[3].text[0]")))]),
    _vm._v(" "),
    _c("p", [_vm._v(_vm._s(_vm.$t("privacy.list[3].text[1]")))]),
    _vm._v(" "),
    _c("p", [_vm._v(_vm._s(_vm.$t("privacy.list[3].text[2]")))]),
    _vm._v(" "),
    _c("p", [_vm._v(_vm._s(_vm.$t("privacy.list[3].text[3]")))]),
    _vm._v(" "),
    _c("p", [_vm._v(_vm._s(_vm.$t("privacy.list[3].text[4]")))]),
    _vm._v(" "),
    _c("p", [_vm._v(_vm._s(_vm.$t("privacy.list[3].text[5]")))]),
    _vm._v(" "),
    _c("h3", [_vm._v(_vm._s(_vm.$t("privacy.list[4].title")))]),
    _vm._v(" "),
    _c("p", [_vm._v(_vm._s(_vm.$t("privacy.list[4].text[0]")))]),
    _vm._v(" "),
    _c("p", { staticClass: "no-margin" }, [
      _vm._v(_vm._s(_vm.$t("privacy.list[4].clarification[0]")))
    ]),
    _vm._v(" "),
    _c("p", { staticClass: "no-margin" }, [
      _vm._v(_vm._s(_vm.$t("privacy.list[4].clarification[1]")))
    ]),
    _vm._v(" "),
    _c("p", { staticClass: "no-margin" }, [
      _vm._v(_vm._s(_vm.$t("privacy.list[4].clarification[2]")))
    ]),
    _vm._v(" "),
    _c("p", { staticClass: "no-margin" }, [
      _vm._v(_vm._s(_vm.$t("privacy.list[4].clarification[3]")))
    ]),
    _vm._v(" "),
    _c("p", { staticClass: "no-margin" }, [
      _vm._v(_vm._s(_vm.$t("privacy.list[4].clarification[4]")))
    ]),
    _vm._v(" "),
    _c("p", { staticClass: "no-margin" }, [
      _vm._v(_vm._s(_vm.$t("privacy.list[4].clarification[5]")))
    ]),
    _vm._v(" "),
    _c("p", { staticClass: "no-margin" }, [
      _vm._v(_vm._s(_vm.$t("privacy.list[4].clarification[6]")))
    ]),
    _vm._v(" "),
    _c("h3", [_vm._v(_vm._s(_vm.$t("privacy.list[5].title")))]),
    _vm._v(" "),
    _c("p", [_vm._v(_vm._s(_vm.$t("privacy.list[5].text[0]")))]),
    _vm._v(" "),
    _c("p", [_vm._v(_vm._s(_vm.$t("privacy.list[5].text[1]")))]),
    _vm._v(" "),
    _c("p", [_vm._v(_vm._s(_vm.$t("privacy.list[5].clarification[0]")))]),
    _vm._v(" "),
    _c("p", [_vm._v(_vm._s(_vm.$t("privacy.list[5].clarification[1]")))]),
    _vm._v(" "),
    _c("p", [_vm._v(_vm._s(_vm.$t("privacy.list[5].clarification[2]")))]),
    _vm._v(" "),
    _c("p", [_vm._v(_vm._s(_vm.$t("privacy.list[5].clarification[3]")))]),
    _vm._v(" "),
    _c("p", [_vm._v(_vm._s(_vm.$t("privacy.list[5].clarification[4]")))]),
    _vm._v(" "),
    _c("p", [_vm._v(_vm._s(_vm.$t("privacy.list[5].clarification[5]")))]),
    _vm._v(" "),
    _c("p", [_vm._v(_vm._s(_vm.$t("privacy.list[5].clarification[6]")))]),
    _vm._v(" "),
    _c("p", [_vm._v(_vm._s(_vm.$t("privacy.list[5].clarification[7]")))]),
    _vm._v(" "),
    _c("p", [_vm._v(_vm._s(_vm.$t("privacy.list[5].clarification[8]")))]),
    _vm._v(" "),
    _c("p", [_vm._v(_vm._s(_vm.$t("privacy.list[5].text[2]")))]),
    _vm._v(" "),
    _c("p", [_vm._v(_vm._s(_vm.$t("privacy.list[5].text[3]")))]),
    _vm._v(" "),
    _c("p", [_vm._v(_vm._s(_vm.$t("privacy.list[5].text[4]")))]),
    _vm._v(" "),
    _c("p", [_vm._v(_vm._s(_vm.$t("privacy.list[5].text[5]")))]),
    _vm._v(" "),
    _c("p", [_vm._v(_vm._s(_vm.$t("privacy.list[5].text[6]")))]),
    _vm._v(" "),
    _c("p", [_vm._v(_vm._s(_vm.$t("privacy.list[5].text[7]")))]),
    _vm._v(" "),
    _c("p", [_vm._v(_vm._s(_vm.$t("privacy.list[5].text[8]")))]),
    _vm._v(" "),
    _c("p", [_vm._v(_vm._s(_vm.$t("privacy.list[5].text[9]")))]),
    _vm._v(" "),
    _c("p", [_vm._v(_vm._s(_vm.$t("privacy.list[5].text[10]")))]),
    _vm._v(" "),
    _c("p", [_vm._v(_vm._s(_vm.$t("privacy.list[5].text[11]")))]),
    _vm._v(" "),
    _c("p", [_vm._v(_vm._s(_vm.$t("privacy.list[5].text[12]")))]),
    _vm._v(" "),
    _c("p", [
      _vm._v(
        _vm._s(
          _vm.$t("privacy.list[5].text[13]", { supportEmail: _vm.supportEmail })
        )
      )
    ]),
    _vm._v(" "),
    _c("h3", [_vm._v(_vm._s(_vm.$t("privacy.list[6].title")))]),
    _vm._v(" "),
    _c("p", [_vm._v(_vm._s(_vm.$t("privacy.list[6].text[0]")))]),
    _vm._v(" "),
    _c("p", [_vm._v(_vm._s(_vm.$t("privacy.list[6].text[1]")))]),
    _vm._v(" "),
    _c("h3", [_vm._v(_vm._s(_vm.$t("privacy.list[7].title")))]),
    _vm._v(" "),
    _c("p", [_vm._v(_vm._s(_vm.$t("privacy.list[7].text[0]")))]),
    _vm._v(" "),
    _c("p", [_vm._v(_vm._s(_vm.$t("privacy.list[7].clarification[0]")))]),
    _vm._v(" "),
    _c("p", [_vm._v(_vm._s(_vm.$t("privacy.list[7].clarification[1]")))]),
    _vm._v(" "),
    _c("h3", [_vm._v(_vm._s(_vm.$t("privacy.list[8].title")))]),
    _vm._v(" "),
    _c("p", [_vm._v(_vm._s(_vm.$t("privacy.list[8].text[0]")))]),
    _vm._v(" "),
    _c("p", [_vm._v(_vm._s(_vm.$t("privacy.list[8].text[1]")))]),
    _vm._v(" "),
    _c("p", [_vm._v(_vm._s(_vm.$t("privacy.list[8].clarification[0]")))]),
    _vm._v(" "),
    _c("p", [_vm._v(_vm._s(_vm.$t("privacy.list[8].clarification[1]")))]),
    _vm._v(" "),
    _c("p", [_vm._v(_vm._s(_vm.$t("privacy.list[8].clarification[2]")))]),
    _vm._v(" "),
    _c("p", [_vm._v(_vm._s(_vm.$t("privacy.list[8].clarification[3]")))]),
    _vm._v(" "),
    _c("p", [_vm._v(_vm._s(_vm.$t("privacy.list[8].clarification[4]")))]),
    _vm._v(" "),
    _c("p", [_vm._v(_vm._s(_vm.$t("privacy.list[8].clarification[5]")))]),
    _vm._v(" "),
    _c("p", [_vm._v(_vm._s(_vm.$t("privacy.list[8].clarification[6]")))]),
    _vm._v(" "),
    _c("p", [_vm._v(_vm._s(_vm.$t("privacy.list[8].clarification[7]")))]),
    _vm._v(" "),
    _c("p", [_vm._v(_vm._s(_vm.$t("privacy.list[8].clarification[8]")))]),
    _vm._v(" "),
    _c("h3", [_vm._v(_vm._s(_vm.$t("privacy.list[9].title")))]),
    _vm._v(" "),
    _c("p", [_vm._v(_vm._s(_vm.$t("privacy.list[9].text[0]")))]),
    _vm._v(" "),
    _c("p", [_vm._v(_vm._s(_vm.$t("privacy.list[9].text[1]")))]),
    _vm._v(" "),
    _c("p", [_vm._v(_vm._s(_vm.$t("privacy.list[9].text[2]")))]),
    _vm._v(" "),
    _c("h3", [_vm._v(_vm._s(_vm.$t("privacy.list[10].title")))]),
    _vm._v(" "),
    _c("p", [_vm._v(_vm._s(_vm.$t("privacy.list[10].text[0]")))]),
    _vm._v(" "),
    _c("h3", [_vm._v(_vm._s(_vm.$t("privacy.list[11].title")))]),
    _vm._v(" "),
    _c("p", [_vm._v(_vm._s(_vm.$t("privacy.list[11].text[0]")))]),
    _vm._v(" "),
    _c("p", [_vm._v(_vm._s(_vm.$t("privacy.list[11].text[1]")))]),
    _vm._v(" "),
    _c("h3", [_vm._v(_vm._s(_vm.$t("privacy.list[12].title")))]),
    _vm._v(" "),
    _c("p", [_vm._v(_vm._s(_vm.$t("privacy.list[12].text[0]")))]),
    _vm._v(" "),
    _c("h3", [_vm._v(_vm._s(_vm.$t("privacy.list[13].title")))]),
    _vm._v(" "),
    _c("p", [_vm._v(_vm._s(_vm.$t("privacy.list[13].text[0]")))])
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }